'use strict';

import mod from './ngmodule';
import './index.scss';

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('./', true, /\.js$/));

export default mod;